import React from 'react';

function Application() {
  return <h1>Void</h1>;
}

export default Application;